import { useFragment } from "@apollo/client/react";
import {
  MarginDecisionGroupFragment,
  MarginDecisionGroupFragmentDoc,
} from "@/graphql/__generated__/graphql";

/**
 * Custom hook to retrieve a MarginDecisionGroup's data from the cache.
 *
 * This hook uses the `useFragment` hook from Apollo Client to automatically
 * subscribe to changes in the MarginDecisionGroup data.
 *
 * @param {{string}} {id} - The MarginDecision from which to retrieve the data.
 * @returns {MarginDecisionGroupFragment | undefined} - The MarginDecisionGroup data or undefined if not available.
 *
 * @example
 * const marginDecisionGroup = useMarginDecisionGroupData("1");
 *
 */
export const useMarginDecisionGroupData = ({ id }: {id: string }): MarginDecisionGroupFragment | undefined => {
  const { data } = useFragment({
    fragment: MarginDecisionGroupFragmentDoc,
    from: {
      __typename: "MarginDecisionGroup",
      _id: id,
    }
  });

  return data as MarginDecisionGroupFragment | undefined;
};
